export class DocumentsAndInformationRoutingConstants {
    static VIEW_DOCUMENTS_AND_INFORMATION_ROUTE = "view-documents-and-information";
}
